// ── Tenant roles ───────────────────────────────────────────────────────────────

// #3565 — the one tenant-role vocabulary: every value tenant_members.role may
// hold. The DB CHECK tenant_members_role_check (migration 0257) admits exactly
// these (pinned by 3565-tenant-role-check.pglite.test.ts), and the API's
// TenantRole (middleware/tenant-auth.middleware.ts) is this type. The write
// paths' Zod accept-sets are narrower subsets, marked `satisfies`. Adding a
// role means a migration too.
export const TENANT_ROLES = ['TENANT_ADMIN', 'TENANT_MEMBER', 'ADMIN', 'CLIENT', 'STUDENT', 'FACULTY_SUPERVISOR'] as const;

export type TenantRole = (typeof TENANT_ROLES)[number];

// ── Project roles ──────────────────────────────────────────────────────────────

// Delivery tier: SI team roles
export const DELIVERY_ROLES = {
  PM:          'PRODUCT_MANAGER',
  ARCHITECT:   'ARCHITECT',
  TECH_LEAD:   'TECH_LEAD',
  DEVELOPER:   'DEVELOPER',
  QA:          'QA_ENGINEER',
  DEVOPS:      'DEVOPS',
  STAKEHOLDER: 'STAKEHOLDER',
} as const;

// Business tier: client-side roles
export const BUSINESS_ROLES = {
  CLIENT_SPONSOR:     'CLIENT_SPONSOR',
  BUSINESS_ANALYST:   'BUSINESS_ANALYST',
  SIGN_OFF_AUTHORITY: 'SIGN_OFF_AUTHORITY',
  END_USER_REP:       'END_USER_REP',
} as const;

export const PROJECT_ROLES = { ...DELIVERY_ROLES, ...BUSINESS_ROLES } as const;

export type DeliveryRole = typeof DELIVERY_ROLES[keyof typeof DELIVERY_ROLES];
export type BusinessRole = typeof BUSINESS_ROLES[keyof typeof BUSINESS_ROLES];
export type ProjectRole = typeof PROJECT_ROLES[keyof typeof PROJECT_ROLES];

const BUSINESS_SET: ReadonlySet<string> = new Set(Object.values(BUSINESS_ROLES));

export function getRoleTier(role: string): 'DELIVERY' | 'BUSINESS' {
  return BUSINESS_SET.has(role) ? 'BUSINESS' : 'DELIVERY';
}
